import { socialLinks } from "./view-state.js";

export function installShareView(getUrl, showToast) {
  const dialog = document.querySelector("#shareDialog");
  const input = document.querySelector("#shareUrl");
  const feedback = document.querySelector("#shareFeedback");
  const nativeButton = document.querySelector("#nativeShareButton");
  let opener;
  const open = event => {
    opener = event.currentTarget;
    input.value = getUrl();
    feedback.textContent = "";
    document.querySelector("#shareNetworks").replaceChildren(...socialLinks(input.value).map(({ label, url }) => {
      const link = document.createElement("a");
      link.textContent = label; link.href = url; link.target = "_blank"; link.rel = "noopener noreferrer";
      link.setAttribute("aria-label", `Partager sur ${label} (nouvel onglet)`);
      return link;
    }));
    nativeButton.hidden = typeof navigator.share !== "function";
    dialog.showModal();
    document.querySelector("#shareCopyButton").focus();
  };
  async function copy(url, inDialog) {
    try {
      await navigator.clipboard.writeText(url);
      if (inDialog) feedback.textContent = "Lien copié"; else showToast("Lien copié");
    } catch {
      if (!inDialog) open({ currentTarget: document.querySelector("#copyButton") });
      input.focus(); input.select();
      feedback.textContent = "Sélectionnez et copiez ce lien : la copie automatique est indisponible.";
    }
  }
  document.querySelector("#shareViewButton").addEventListener("click", open);
  document.querySelector("#shareButton").addEventListener("click", open);
  document.querySelector("#copyButton").addEventListener("click", () => copy(getUrl(), false));
  document.querySelector("#shareCopyButton").addEventListener("click", () => copy(input.value, true));
  document.querySelector("#closeShare").addEventListener("click", () => dialog.close());
  dialog.addEventListener("close", () => opener?.focus());
  dialog.addEventListener("click", event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
  nativeButton.addEventListener("click", async () => {
    try { await navigator.share({ title: "Entourages", url: input.value }); }
    catch (error) { if (error.name !== "AbortError") feedback.textContent = "Partage indisponible. Vous pouvez copier le lien."; }
  });
}
